/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const ListIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
    <path
      d="M7.75 6.375H19.9375M7.75 12H19.9375M7.75 17.625H19.9375M3.0625 6.375H3.07187M3.0625 12H3.07187M3.0625 17.625H3.07187"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
